import { render } from "./CopyUsersIntoGroup.vue?vue&type=template&id=2f9f5a3d"
import script from "./CopyUsersIntoGroup.vue?vue&type=script&lang=js"
export * from "./CopyUsersIntoGroup.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__